/* eslint-disable default-param-last */
import ip from "icepick";
import { combineReducers } from "redux";
import { Interest, View } from "../../types";
import { updateSectionItems } from "../../utils/utils";
import {
  ACTIVE_VIEW_IDX,
  INTERESTS,
  RESET_ITEMS,
  SET,
  SHOW_INTRO,
  STORY,
  UNSET,
  UPDATE_ITEMS,
  UPDATE_PROPERTY,
  UPDATE_SECTIONS,
  UPDATE_SECTIONS_PROPERTY,
  VIEWS
} from "./type";

const intialViewsState: View[] = ip.freeze([]);
const initialInterestState: Interest[] = ip.freeze([]);
const initialStoryState = ip.freeze({
  show: false,
  activeIdx: -1,
  stories: [],
});

const views = (state = intialViewsState, action) => {
  const { viewIdx, sectionIdx } = action;
  switch (action.type) {
    case VIEWS[SET]:
      // @ts-ignore
      state = ip.set([...action.data]);
      break;
    case VIEWS[UNSET]:
      // @ts-ignore
      state = ip.set([]);
      break;
    case VIEWS[UPDATE_SECTIONS]: {
      const { sections, offset } = action;
      const currSections =
        offset !== null ? ip.getIn(state, [viewIdx, "sections"]) : [];
      state = ip.updateIn(state, [viewIdx, "sections"], () => [
        ...currSections,
        ...sections,
      ]);
      break;
    }
    case VIEWS[UPDATE_ITEMS]: {
      const { items } = action;
      const currItems = ip.getIn(state, [
        viewIdx,
        "sections",
        sectionIdx,
        "items",
      ]);

      state = ip.updateIn(
        state,
        [viewIdx, "sections", sectionIdx, "items"],
        () => [...currItems, ...items]
      );
      break;
    }
    case VIEWS[RESET_ITEMS]: {
      const { items } = action;
      const currItems = ip.getIn(state, [
        viewIdx,
        "sections",
        sectionIdx,
        "items",
      ]);

      state = ip.updateIn(
        state,
        [viewIdx, "sections", sectionIdx, "items"],
        () => items
      );
      break;
    }
    case VIEWS[UPDATE_PROPERTY]: {
      const { id, propertyKey, propertyVal } = action;
      state = updateSectionItems(
        ip.getIn(state, []),
        id,
        propertyKey,
        propertyVal
      );

      break;
    }
    case VIEWS[UPDATE_SECTIONS_PROPERTY]: {
      const { viewIdx, sectionIdx, propertyKey, propertyVal } = action;
      state = ip.updateIn(
        state,
        [viewIdx, "sections", sectionIdx, propertyKey],
        () => propertyVal
      );
    }
    default:
      break;
  }

  return state;
};

const activeViewIdx = (state = 0, action) => {
  switch (action.type) {
    case ACTIVE_VIEW_IDX[SET]:
      return action.data;
    case ACTIVE_VIEW_IDX[UNSET]:
      return 0;
    default:
      return state;
  }
};
const story = (state = initialStoryState, action) => {
  switch (action.type) {
    case STORY[SET]:
      return { ...state, ...action.data };
    case STORY[UPDATE_PROPERTY]: {
      const { idx, propertyKey, propertyVal } = action;
      return ip.updateIn(
        state,
        ["stories", idx, propertyKey],
        () => propertyVal
      );
    }
    case STORY[UNSET]:
      return initialStoryState;
    default:
      return state;
  }
};

const showIntro = (state = false, action) => {
  switch (action.type) {
    case SHOW_INTRO[SET]:
      return true;
    case SHOW_INTRO[UNSET]:
      return false;
    default:
      return state;
  }
};

const interests = (state = initialInterestState, action) => {
  const { idx, isSelected } = action;
  switch (action.type) {
    case INTERESTS[SET]:
      // @ts-ignore
      state = ip.set([...action.data]);
      break;
    case INTERESTS[UPDATE_ITEMS]:
      state = ip.updateIn(state, [idx, "isSelected"], () => isSelected);
      break;
    case INTERESTS[UNSET]:
      // @ts-ignore
      state = ip.set([]);
      break;
    default:
      break;
  }
  return state;
};

export default function discoverReducer() {
  return combineReducers({
    views,
    activeViewIdx,
    interests,
    story,
    showIntro,
  });
}
